import React, { FunctionComponent } from 'react'
import GridViewIcon from '../../atoms/Icons/GridViewIcon/GridViewIcon'
import ListViewIcon from '../../atoms/Icons/ListViewIcon/ListViewIcon'
import DocumentSort, { SortBy } from '../DocumentSort/DocumentSort'
import SearchBar from '../SearchBar/SearchBar'
import * as S from './styled'
import CreateDocumentButton from '../CreateDocumentButton'

type OwnProps = {
  listView: boolean
  setListView: React.Dispatch<React.SetStateAction<boolean>>
  setSearch: React.Dispatch<React.SetStateAction<string>>
  setSortBy: React.Dispatch<React.SetStateAction<SortBy>>
}

type Props = OwnProps

export const DocumentUtilsBar: FunctionComponent<Props> = ({
  listView,
  setListView,
  setSearch,
  setSortBy,
}) => {
  return (
    <S.Container>
      <DocumentSort setSortBy={setSortBy} />
      <CreateDocumentButton />

      <SearchBar setSearch={setSearch} />
      <S.IconContainer>
        <S.GridViewIconBox listView={listView} onClick={() => setListView(false)}>
          <GridViewIcon active={!listView} />
        </S.GridViewIconBox>

        <S.ListViewIconBox listView={listView} onClick={() => setListView(true)}>
          <ListViewIcon active={listView} />
        </S.ListViewIconBox>
      </S.IconContainer>
    </S.Container>
  )
}

export default DocumentUtilsBar
